import { useForm } from 'react-hook-form';

export interface NewPaymentLinkForm {
  amount: number;
  id_merchant: string;
  concept: string;
  has_expiration_date: boolean;
  expiration_date?: Date;
}

// id_merchant 40 = "Pruebas Wuzi" (comercio de pruebas fijo, confirmado contra el BFF
// real), seleccionado por default para no tener que elegirlo manualmente cada vez.
// Comentado para el PR a development: el usuario debe seleccionar su propia sucursal real.
const initialValues: Partial<NewPaymentLinkForm> = {
  has_expiration_date: false,
  // id_merchant: '40',
};

export const useCreatePaymentLinkForm = () => {
  const { register, handleSubmit, watch, reset, control, formState: { errors } } = useForm<NewPaymentLinkForm>({
    defaultValues: initialValues,
  });

  const hasExpirationDate = watch('has_expiration_date');

  return {
    controls: {
      amount: register('amount', {
        required: 'Este campo es requerido.',
        min: { value: 1, message: 'El monto debe ser mayor a 0.' },
      }),
      concept: register('concept', {
        required: 'Este campo es requerido.',
        maxLength: { value: 100, message: 'El concepto no puede exceder los 100 caracteres.' },
      }),
      has_expiration_date: register('has_expiration_date'),
      expiration_date: register('expiration_date', {
        validate: (value) => !hasExpirationDate || !!value || 'Selecciona una fecha de expiración.',
      }),
    },
    hasExpirationDate,
    handleSubmit,
    reset,
    control,
    errors,
  };
};
